export const getOpenGraphLocaleFormatter = () => {
  const format = (locale: MaybeRef<string>) => {
    const toplevellocale = getTopLevelLocale(toValue(locale))
    return `${toplevellocale.toLocaleLowerCase()}_${toplevellocale.toUpperCase()}`
  }
  return { format }
}
